const inventory = [
    { id: 'misc', name: 'Miscellaneous' },
    { id: 'bundles', name: 'Bundles' },
    { id: 'beverages', name: 'Beverages' },
    { id: 'clothing', name: 'Clothing' },
    { id: 'containers', name: 'Containers' },
    { id: 'electronics', name: 'Electronics' },
    { id: 'food', name: 'Food' },
    { id: 'materials', name: 'Materials' },
    { id: 'household', name: 'Household' },
    { id: 'office', name: 'Office' },
    { id: 'technology', name: 'Technology' },
    { id: 'tools', name: 'Tools' },
    { id: 'transportation', name: 'Transportation' }
]

export default inventory
